// If you want to change this, please check the following file
// ./engines/applicant_tracking/app/services/applicant_tracking/application_service/submit_application.rb
export const ORGANIC_POSTING_PARAM = 'organic-posting-network-source-param';

export interface CareersJobBoardParams {
  source?: string;
  campaign?: string;
  provider?: string;
}
